import { useState, useEffect } from 'react'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import AccessLevelList from 'components/Lists/AccessLevelList'
import SecondaryButton from 'components/Buttons/SecondaryButton'
import AccessLevelModal from 'pages/Modals/AccessLevelModal'
import { ReactComponent as Loading } from 'icons/loading2.svg'
import { Container, Row } from '../../styles'

export default function AccessLevels () {
  const [loading, setLoading] = useState (true)
  const [accessLevels, setAccessLevels] = useState ([])
  const [permissions, setPermissions] = useState ([])
  const [selectedAccessLevel, setSelectedAccessLevel] = useState ({})
  const [showAccessLevelModal, setShowAccessLevelModal] = useState (false)
  const token = AuthService.getToken ()
  const businessId = AuthService.getBusinessId ()

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  useEffect (() => {
    getData ()
  }, [])

  const getData = async () => {
    try {
      const [{ data: accessLevels }, { data: permissions }] = await Promise.all ([
        cutileiApi.get (`/access_levels?business_id=${businessId}`, requestConfig),
        cutileiApi.get ('/permissions', requestConfig)
      ])

      setAccessLevels (accessLevels)
      setPermissions (permissions)
      setSelectedAccessLevel (accessLevels[0])
    } catch (error) {
      logApiError (error)
    } finally {
      setLoading (false)
    }
  }

  const toggleAccessLevelModal = () => setShowAccessLevelModal (!showAccessLevelModal)

  if (loading) return <Loading style={{marginTop: 30}}/>

  return (
    <Container>
      <Row>
        <SecondaryButton
          label='Criar nível de acesso'
          onClick={toggleAccessLevelModal}
          width={180}
        />
      </Row>
      <AccessLevelList
        accessLevels={accessLevels}
        permissions={permissions}
        selectedAccessLevel={selectedAccessLevel}
        onItemSelected={setSelectedAccessLevel}
        onEdit={accessLevel => {
          setAccessLevels (accessLevels.map (al => al.id === accessLevel.id ? {...accessLevel} : al))
        }}
        onDelete={accessLevel => {
          setAccessLevels (accessLevels.filter (al => al.id !== accessLevel.id))
        }}
      />
      <AccessLevelModal
        visible={showAccessLevelModal}
        permissions={permissions}
        accessLevels={accessLevels}
        onClose={toggleAccessLevelModal}
        onConfirm={accessLevel => setAccessLevels ([...accessLevels, accessLevel])}
      />
    </Container>
  )
}
